import Switch, {Case, Default} from 'react-switch-case';
import React, {Component} from 'react';
import Plot from './Plot'
import Line from './Line'
import PropTypes from 'prop-types';
import * as firebase from 'firebase';

class Switcher extends Component {
    constructor() {
        //console.log("Switcher created");
        super();
        this.state = {
            value: "Candlestick",
            timeseries: []
        }
    }

    handleChange(event) {
        ///console.log("Switcher handleChange");
        this.setState({value: event.target.value})
    }

    shouldComponentUpdate(){
      if (this.canRender){
        this.canRender = false;
        return true;
      }
      return false;
    }

    componentDidMount() {
        //console.log("Switcher componentDidMount");
        //console.log("mounting");
        //would you rather get a whole new array or just one new point?
        const self = this;
        this.canRender = true;
        this.renderLoop = setInterval(()=>{ self.canRender = true; }, 1000);
        const validatePoint = function (newpt) {
            if (newpt.price === 0) {
                return false;
            }
            let theTime = new Date(newpt.time);
            if (theTime.getUTCHours() > 16) {
                return false;
            } else if (theTime.getUTCHours() === 16 && theTime.getUTCMinutes() >= 1) {
                return false;
            } else if (theTime.getUTCHours() < 9) {
                return false;
            } else if (theTime.getUTCHours() === 9 && theTime.getUTCMinutes() < 30) {
                return false;
            }
            return true;
        };

        let newItems = false;

        this.timeseriesRef = this.props.db.child("Sessions").child(this.props.sessionid).child("TimeSeries");     
          // Ah, here's the rub.  We just throw the "MarketVWAP" calculation in the DB here     - Nathan Bendich,   May 12, 2022.
          // But there are still a few questions: where should/is the actual VWAP calculation done?   Should it be in the "pnt" variable or in the database, or?     I think within "Sessions", the value should be stored s.t. "el.VWAP" in Line.js ends up being what we graph

        this.timeseriesRef.on('child_added', snap => {
            if (!newItems) return;
            let pnt = snap.val();
            //console.log("added", pnt);
            let pointHandler = function (newpt) {
                //console.log(theTime.toUTCString());
                //console.log("point handler called");
                if (!validatePoint(newpt)) {
                    //console.log("invalid",newpt);
                    return null;
                }
                const timeseries = self.state.timeseries;
                timeseries.push(newpt);
                //console.log("updated with",newpt);
                self.setState({
                    timeseries: timeseries
                })
                self.props.passPoint(newpt);
            };
            pointHandler(pnt);
        }); //end the child_added
        this.timeseriesRef.once('value', snap => {  // NOTE:  we've seen this "once()" function elsewhere; is it a function only defined in TraderEx?    -nxb,  June 4, 2022
            //console.log("loading values once only!!");
            newItems = true;
            const timeseries = self.state.timeseries;
            snap.forEach(pnt => {
                if (!validatePoint(pnt)) {
                    return null;
                } else {
                    timeseries.push(pnt.val());
                }
            });
            self.setState({
                timeseries: timeseries
            });
            if (timeseries.length > 0){
              self.props.passPoint(timeseries[timeseries.length-1]);
            }

        });//end the once() func


        //TODO:hopefully this doesnt break it
        // var trace1 = {
        // 	x: [],
        // 	y: [],
        // 	type: 'scatter'
        // };
        //
        // var trace2 = {
        // 	x: [],
        // 	y: [],
        // 	type: 'scatter'
        // };


        //THIS ONE WORKS
        // for (var i=0; i<timeseries1.length; i++) {
        //     pointHandler(timeseries1[i]);
        // }

        // for (var i=0; i<timeseries2.length; i++) {
        //   trace2.x.push(timeseries2[i]["time"]);
        //   trace2.y.push(timeseries2[i]["price"]);
        // }


    }

    componentWillUnmount() {
        //console.log("Switcher componentWillUnmount");
        this.timeseriesRef.off();
    }


    render() {
        //console.log("Switcher render");
        const style = {
            float: 'none',
            margin: '0 auto'
        };
        return (

            <div className="graph-switcher">
                <select
                    ref="selectOption"
                    onChange={(e) => this.handleChange(e)}>
                    <option defaultValue="Candlestick">Candlestick</option>
                    <option value="Line">Line
                    </option>
                </select>

                <Switch condition={this.state.value}>
                    <Case value='Candlestick'>
                        <Plot timeseries={this.state.timeseries}/>
                    </Case>
                    <Case value='Line'>
                        <Line timeseries={this.state.timeseries}/>
                    </Case>
                    <Default>
                        <span>Nothing!</span>
                    </Default>
                </Switch>
            </div>
        );
    }
}

Switcher.propTypes = {
    sessionid: PropTypes.string
};

export default Switcher;



// WEBPACK FOOTER //
// ./src/components/Charts/Switcher.js